'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { parseAsBoolean, useQueryStates } from 'nuqs';
import { disablePreviewMode } from '@/app/api/preview/disable';
import { PhosphorIcon } from '@/components/icons/PhosphorIcon';
import type { CmsApiOptions } from '@/services/cms-sdk';
export interface PreviewModeIndicator extends CmsApiOptions {
  pageId?: number;
}
export function PreviewModeIndicator(t0) {
  const $ = _c(9);
  const {
    pageId
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      cmsPreview: parseAsBoolean
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [t2] = useQueryStates(t1);
  const {
    cmsPreview
  } = t2;
  let t3;
  let t4;
  if ($[1] !== cmsPreview) {
    t3 = () => {
      if (cmsPreview) {
        fetch("/api/preview?redirect=false", {
          method: "DELETE"
        }).then(_temp).catch(_temp2);
      }
    };
    t4 = [cmsPreview];
    $[1] = cmsPreview;
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  useEffect(t3, t4);
  if (cmsPreview) {
    return null;
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <button className="btn btn--circular"><PhosphorIcon className="text-[20px]" name="pencil-simple" /></button>;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <li><a onClick={_temp3}><PhosphorIcon className="text-[16px]" name="eye" /> Exit preview mode</a></li>;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const t7 = `/admin/pages/edit/show/${pageId}`;
  let t8;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <PhosphorIcon className="text-[16px]" name="pencil-simple" />;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  let t9;
  if ($[7] !== t7) {
    t9 = <div className="dropdown dropdown-top dropdown-end fixed bottom-6 right-6 z-50">{t5}<ul tabIndex={0} className="dropdown-content menu bg-base-100 rounded-box z-1 w-52 p-2 shadow-sm">{t6}<li><a href={t7} target="_blank" rel="noreferrer">{t8} Edit in cms</a></li></ul></div>;
    $[7] = t7;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  return t9;
}
function _temp3() {
  return disablePreviewMode();
}
function _temp2() {}
function _temp() {}